import React, { useEffect, useState } from 'react'
import { Card, Select, Button, Row, ConfigProvider, Skeleton } from 'antd'
import { useOutletContext, Link } from "react-router-dom";
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";

import { setTitleProgramAttendance } from "../../../../redux/features/blended_learning/scannerSlice";
import BGScanner from '../../../../assets/images/png/feature/scanner/bg_scanner.png'

import HomeTitle from "../../../../components/HomeTitle/index";

import { colorTextTitle, ColorQuartenari, ColorPrimary } from '../../../../config/constant/color/index'

// for translate
import { useTranslation } from "react-i18next";

const Scanner = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
    const [
            loading,
            userData,
            totalJourney,
            totalJourneyCompleted,
            allJourneyData,
            listJourney,
            listCourse,
            mainState
        ] = useOutletContext();
    const [ chooseProgram, setChooseProgram ] = useState(false);
    const [ filter, setFilter ] = useState()
    const [ programData, setProgramData ] = useState([]);
    const [ empty, setEmpty] = useState(false);
    

    const handleChange = (value, option) => {
        setFilter(value);
        dispatch(setTitleProgramAttendance(option.name))
    };

    const modifiedDropdown = (data) => {
        const modified = data.map((item, index) => {
            return {
                value: item.id,
                label: <span data-index={index} style={{fontSize:14,color:"#67686D"}}>{item.name}</span>,
                name: item.name
            }
        });
        
        setProgramData([...modified]);
    }

    useEffect(() => {
        if(listJourney.length) modifiedDropdown(listJourney);
    },[listJourney])

    useEffect(() => {
        if(loading == false && listJourney.length == 0) setEmpty(true)
    },[loading,listJourney])


    const HomeTitleText = t(
        "feature.feature_scanner.title",
    );

    return(
        <ConfigProvider
        theme={{
          token: {
              fontFamily: "Roboto",
              colorPrimary: ColorPrimary,
            },
          components: {
            Table: {
              rowSelectedHoverBg: "none",
              rowSelectedBg: "none",
            },
          },
        }}
      >
        <div style={{width:'100%',height:"100%",background:ColorQuartenari,display:"flex",alignItems:'center',justifyContent:"flex-start",flexDirection:"column"}}>
            <Row align={"top"} style={{
                // marginBottom: programData.length > 0 ? 150 : 0,
                marginBottom: programData.length > 0 ? 150 : empty == false ? 150 : 0,
                marginLeft:0,
                marginRight:"auto",
                lineHeight: "normal",
                padding:"20px 40px"
            }}>
              <div style={{
                width: "100%",
            }}>
                <HomeTitle textTitle={HomeTitleText} dynamic={false} />
              </div>
            </Row>
            {
                programData.length > 0 ?
                <Card bodyStyle={{padding:32}} className='box-program-scanner' style={{width:424,height:184,borderRadius:24}}>
                    <div style={{}}>
                        <div>
                            <Select
                                className='dropdown-choose-program'
                                name='dropdown-choose-program'
                                placement='bottomRight'
                                size={"large"}
                                style={{
                                    width: 360,
                                    height:40
                                }}
                                listHeight={220} // spesific count list data appear on dropdown when visible
                                placeholder={t("feature.feature_scanner.select_program")}
                                onChange={handleChange}
                                options={programData}
                                popupClassName="dropdown-choose-program"
                                onDropdownVisibleChange={(open) => setChooseProgram(!chooseProgram)}
                                suffixIcon={
                                    chooseProgram ?
                                    <UpOutlined style={{
                                            color:colorTextTitle,
                                            pointerEvents:"none",
                                            fontSize:14
                                        }} />
                                    :
                                    <DownOutlined style={{
                                        color:colorTextTitle,
                                        pointerEvents:"none",
                                        fontSize:14
                                    }} />
                                }
                            />
                        </div>
                        <div style={{marginTop:32}}>
                            <Link 
                                to={filter !== undefined ? `/scan/${filter}/attendance` : ""}
                            >
                                <Button
                                    disabled={filter !== undefined ? false : true}
                                    role="button"
                                    className="btn btn-primary btn-sm btn-choose-program btn-block"
                                    style={{ borderRadius: 6, border: '1px solid #FFFFFF', fontSize:14, fontWeight:'500', height:48,color:"#FFFFFF" }}
                                    name="btn-choose-program"
                                >
                                    OK
                                </Button>
                            </Link>
                        </div>
                    </div>
                </Card>
                :
                    empty == false ? 
                    <Card bodyStyle={{padding:32}} className='box-program-scanner' style={{width:424,height:184,borderRadius:24}}>
                        <div style={{}}>
                            <div>
                                <Skeleton.Input
                                    active
                                    size={20}
                                    style={{ width: 360,
                                    height:40 }}
                                />
                            </div>
                            <div style={{marginTop:32}}>
                                <Button
                                    disabled={true}
                                    loading={true}
                                    role="button"
                                    className="btn btn-primary btn-sm btn-choose-program btn-block"
                                    style={{ borderRadius: 6,width:"100%", border: '1px solid #FFFFFF', fontSize:14,fontWeight:'500', height:48,color:"#FFFFFF" }}
                                    name="btn-choose-program"
                                >
                                    
                                </Button>
                            </div>
                        </div>
                    </Card>
                    :
                    <div style={{lineHeight:"normal",width:"100%",textAlign:"left",paddingLeft:40,fontWeight:500,fontSize:14}}>
                        {t("feature.feature_scanner.no_programs")}
                    </div>
            }
        </div>
        </ConfigProvider>
    )
}

export default Scanner